import { render, staticRenderFns } from "./BaseManagement.vue?vue&type=template&id=5241cf6a&scoped=true&"
import script from "./BaseManagement.vue?vue&type=script&lang=js&"
export * from "./BaseManagement.vue?vue&type=script&lang=js&"
import style0 from "./BaseManagement.vue?vue&type=style&index=0&id=5241cf6a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5241cf6a",
  null
  
)

export default component.exports